let dateArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
let weekEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
let obj = {};
let time;
const timeObj = (format = '1') => {
    let DateTime = new Date();
    let year = DateTime.getFullYear();
    let month = DateTime.getMonth() + 1;
    let month1 = month > 9 ? month : "0" + month;
    let date = DateTime.getDate();
    let date1 = date > 9 ? date : "0" + date;
    let day = DateTime.getDay();
    let week = dateArr[day];
    let hour = DateTime.getHours();
    let hour1 = hour > 9 ? hour : "0" + hour;
    let minutes = DateTime.getMinutes();
    let minutes1 = minutes > 9 ? minutes : "0" + minutes;
    let seconds = DateTime.getSeconds();
    let seconds1 = seconds > 9 ? seconds : "0" + seconds;
    let week1 = weekEn[day];
    obj = {
        1: `${year}年${month1}月${date1}日 ${week}`,
        2: `${year}年${month1}月${date1}日 ${hour1}:${minutes1}`,
        3: `${year}年${month1}月${date1}日 ${week} ${hour1}:${minutes1}`,
        4: `${year}-${month1}-${date1}`,
        5: `${year}-${month1}-${date1} ${hour1}:${minutes1}`,
        6: `${year}/${month1}/${date1} ${week1}`,
        7: `${year}/${month1}/${date1} ${hour1}:${minutes1}`,
        8: `${year}/${month1}/${date1} ${week1} ${hour1}:${minutes1}`
    };
    return obj[format];
};
export default timeObj;
